import { Store } from "pullstate";
import { Hash } from "viem";

/**
 * WARNING: This is not the best practice, so please add interaction states to
 * this file with caution.
 *
 * You should only resort to using InteractionStore if you find yourself in an
 * awkward state sharing interactivity variables between components
 * that are not located adjacently.
 *
 * - Whenever you add a state to this file, preface it with comments explaining
 *   what it does clearly.
 * - The first word in the state name should start with the page route (e.g. trade,
 *   activity).
 */
export interface InteractionStoreSchema {
  // Allows AmountBar to access the openBalancePercentages util function from
  // TradeLegTaker/TradeLegMaker. It allows the user to open a particular trade
  // leg when they click on a specific segment within the amount bar (e.g. if
  // user clicks on the AAVE segment, the trade leg containing AAVE opens)
  tradeLegToOpenOnAmountBarClick: Hash | undefined;
}

export const InteractionStore = new Store<InteractionStoreSchema>({
  tradeLegToOpenOnAmountBarClick: undefined,
});
